import { useToggle } from 'react-use';

import { FileEditIcon, FilePlusIcon, Link, Tooltip } from '@dreryk/react-components';

import { VisitSettlementMedicalServicesUpdateEventInterceptor } from '../../../shared/medicalServices/VisitSettlementMedicalServicesUpdateEventInterceptor';
import { visitSettlementTranslationKeys } from '../../../translations';
import { VisitSettlementControl } from '../../../visitSettlement.types';
import { getVisitSettlementValue } from '../../../visitSettlement.utils';

import { VisitSettlementPriceChangeReasonModal } from './VisitSettlementPriceChangeReasonModal';

const t = visitSettlementTranslationKeys.extensions.visitForm.priceChangeReason.action;

type VisitSettlementPriceChangeReasonActionProps = {
   readonly control: VisitSettlementControl;
   readonly appointmentId: number;
};

export const VisitSettlementPriceChangeReasonAction = (
   props: VisitSettlementPriceChangeReasonActionProps
): JSX.Element => {
   const [modalOpened, toggleModalOpened] = useToggle(false);

   const { priceChangeReason } = getVisitSettlementValue(props.control);

   return (
      <>
         <VisitSettlementMedicalServicesUpdateEventInterceptor
            appointmentId={props.appointmentId}
            control={props.control}
            blockingOperation
         >
            <Tooltip testId={'priceChangeReason'} content={priceChangeReason ? t.tooltip.edit : t.tooltip.plus}>
               <Link
                  testId={'priceChangeReason'}
                  icon={priceChangeReason ? <FileEditIcon /> : <FilePlusIcon />}
                  onClick={toggleModalOpened}
               />
            </Tooltip>
         </VisitSettlementMedicalServicesUpdateEventInterceptor>
         {modalOpened ? (
            <VisitSettlementPriceChangeReasonModal
               appointmentId={props.appointmentId}
               onCancel={toggleModalOpened}
               onPriceChangeReason={(priceChangeReasonAfterChange) => {
                  props.control.setValue('visitSettlement.priceChangeReason', priceChangeReasonAfterChange);
                  toggleModalOpened(false);
               }}
               initializer={() => {
                  return {
                     priceChangeReason: priceChangeReason,
                  };
               }}
            />
         ) : null}
      </>
   );
};
